import { api } from "../../api";

export default async function getPlanDetails() {
  try {
    const { status, data } = await api.get("/billing/customer/plan-details");

    if (status === 200) {
      return data;
    }

    return null;
  } catch (err) {
    console.log(err);

    return null;
  }
}
